import {request} from './request_loc'
import Cookies from 'js-cookie'
import qs from 'qs'

export function getEBadyProductSalesSummary(parameter) {
    var maker_id = Cookies.get("maker_id");
    return request({url:'/order3/getList?page='+page+'&maker_id='+maker_id,method:'post',data:qs.stringify(parameter)})
}